import type { JSX } from 'react';

import { GooglePlacesProvider } from 'src/app/shared/hooks/googlePlaces';

import type { PlaceWithDetailsFieldProps } from './PlaceWithDetailsField';
import { PlaceWithDetailsField } from './PlaceWithDetailsField';

export function PlaceWithDetailsFieldWrapper(props: PlaceWithDetailsFieldProps): JSX.Element {
	return (
		<GooglePlacesProvider>
			<PlaceWithDetailsField {...props} />
		</GooglePlacesProvider>
	);
}
